var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelMug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.406,
    height: 32,
    viewBox: "0 0 25.406 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-glass-cup-6204256",
    transform: "translate(-23.6 -20.313)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    id: "Layer_20",
    "data-name": "Layer 20",
    transform: "translate(23.6 20.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M46.417,20.313H26.189v3.8H23.6V30h2.088L28.16,52.313H44.448L46.92,30h2.086V24.115H46.417ZM43.155,50.87h-13.7L27.141,30H45.467Zm4.409-25.31v3H25.044v-3H37.994V24.117H27.633V21.759H44.973v2.358H43.8V25.56h3.762Z",
    transform: "translate(-23.6 -20.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M45.331,61.792A4.331,4.331,0,1,0,41,57.462a4.331,4.331,0,0,0,4.331,4.331Zm-.722-7.121v3.2h1.444v-3.2a2.887,2.887,0,1,1-1.444,0Z",
    transform: "translate(-32.628 -37.34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelMug);
export default __webpack_public_path__ + "static/media/travelMug.ee8be4e7de3bf76693e74f91c6ff2c20.svg";
export { ForwardRef as ReactComponent };